<script setup lang="ts">

import {Dialog, DialogContent, DialogTrigger} from "@/core/components/ui/dialog";
import BaseButton from "@/core/components/base/BaseButton.vue";
import useGroupingsAdvantages from "@/advantage/composables/useGroupingsAdvantages";
import {Skeleton} from "@/core/components/ui/skeleton";
import {ref} from "vue";

const {allowOpen = true} = defineProps<{
    allowOpen?: boolean
}>();

const open = ref(false);

const {data, isLoading} = useGroupingsAdvantages();

const handleOpen = (value: boolean) => {
    if (allowOpen) {
        open.value = value;
    }
};
</script>

<template>
  <Dialog :open="open" @update:open="handleOpen">
    <DialogTrigger as-child>
      <BaseButton density="comfortable" class="text-primary" prepend-icon="mdi-tag">
        <slot>
          Voir les offres groupements
        </slot>
      </BaseButton>
    </DialogTrigger>
    <DialogContent class="max-w-3xl">
      <div class="space-y-4">
        <div>
          <h2>Nos partenaires vous offrent des avantages sur Apodis</h2>
          <p>Demandez votre code de réduction à votre partenaire !</p>
        </div>
        <div class="flex gap-4 flex-wrap items-center">
          <template v-if="isLoading">
            <Skeleton v-for="i in 4" :key="i" class="h-32 w-32" />
          </template>
          <template v-else>
            <div v-for="advantage in data" :key="advantage.id">
              <img v-if="advantage.logo" class="h-32 w-32 object-contain" :src="advantage.logo" :alt="advantage.title">
            </div>
          </template>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<style scoped>

</style>
